export class Region {
  id: number;
  name: string;
  acronym: string;
  description: string;
}
